import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpUniversalService } from '@services/http';
import { OfferwallMfoItem } from '@models/offerwall.model';
import { BlacklistConfig } from '@services/ipBlacklist.service';

@Injectable({
  providedIn: 'root',
})
export class IpBlacklistApiService {
  protected readonly http = inject(HttpUniversalService);

  getConfigs(): Observable<BlacklistConfig> {
    return this.http.fetchGet<BlacklistConfig>(`/settings/ip/blacklists`);
  }
}
